import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  CRow,
  CCol,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
  CSidebarHeader,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

// import { logoNegative } from 'src/assets/brand/logo-negative'
// import { logoNegative } from 'src/assets/brand/logo-negative-salescube'
// import { sygnet } from 'src/assets/brand/sygnet'
import { sygnet } from 'src/assets/brand/sygnet-salescube'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import * as cusUrlUtil from 'src/viewsCommon/CusUrlUtil'

// sidebar nav config
// import navigation from '../_nav'
// import navigation from '../_navCus'
var navigation
const userPermission = cusUtil.checkUserPermission()
const cid = cusUtil.getCid()

// console.log('userPermission', userPermission)
if (cusUtil.getCid() === 'pwan') {
  switch (userPermission) {
    case 'root':
    case 'admin':
    case 'cadmin':
    case 'cmanager':
      navigation = require('../viewsCus/_company/menu/' + cid + '/_navCusAdmin_' + cid).default
      break
    case 'user':
    default:
      navigation = require('../viewsCus/_company/menu/' + cid + '/_navCusUser_' + cid).default
  }
} else {
  navigation = require('../_navCus').default
}

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  // console.log('unfoldable: ', unfoldable)
  // console.log('sidebarShow: ', sidebarShow)

  return (
    <CSidebar
      className="bg-dark-gradient"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex">
        {/* <CIcon className="sidebar-brand-full mt-2" icon={logoNegative} height={30} /> */}
        {/* <CIcon className="sidebar-brand-narrow mt-2" icon={sygnet} height={30} /> */}

        {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_YN'] === 'n' && (
          <a href="/">
            <div className="sidebar-brand-full fs-5 fw-semibold mb-0">
              {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}
            </div>
          </a>
        )}
        {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_YN'] === 'y' && (
          <a href="/">
            <img
              className="d-block mw-200px mh-35px"
              src={cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_SVG']}
              alt="slide 1"
            />
          </a>
        )}

        <div className="sidebar-brand-narrow fs-5 fw-semibold mb-0">TB</div>
        <CSidebarToggler
          onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
